import { Coordinate } from '_lib/api';
import { useLocalization } from '@fluent/react';
import { Box, Button, Typography } from '@material-ui/core';
import React from 'react';

import { DenmColors } from '../../../../routes/MapView/utils';

interface TracesListProps {
  selectedTraceIndex: number;
  highlightTrace: (index: number) => void;
  deleteTrace: (index: number) => void;
  index: number;
  tracePoints: Coordinate[];
  traceNumberOffset?: number;
}

// eslint-disable-next-line import/prefer-default-export
export const TracesList = ({
  selectedTraceIndex,
  highlightTrace,
  deleteTrace,
  index,
  tracePoints,
  traceNumberOffset = 2,
}: TracesListProps) => {
  const { l10n } = useLocalization();

  const borderLeft = selectedTraceIndex === index ? `4px solid ${DenmColors.TRACE_SELECTED}` : '';
  const paddingLeft = selectedTraceIndex === index ? '10px' : '0px';

  if (tracePoints.length === 0) {
    return null;
  }

  return (
    <Box display={'flex'} key={index} justifyContent={'space-between'} marginTop={'20px'}>
      <Typography
        style={{ alignSelf: 'center', cursor: 'pointer', borderLeft, paddingLeft }}
        variant="caption"
        onClick={() => highlightTrace(index)}
      >{`${l10n.getString('forms-denm-single-trace-zone')} ${index + traceNumberOffset}`}</Typography>
      <Button
        variant="outlined"
        onClick={() => {
          deleteTrace(index);
        }}
        color="primary"
        style={{ borderRadius: 20, textTransform: 'none', fontSize: '11px' }}
        size="small"
      >
        {l10n.getString('forms-denm-points-delete')}
      </Button>
    </Box>
  );
};
